import { render, staticRenderFns } from "./Opinion.vue?vue&type=template&id=a0544474&scoped=true&"
import script from "./Opinion.vue?vue&type=script&lang=ts&"
export * from "./Opinion.vue?vue&type=script&lang=ts&"
import style0 from "./Opinion.vue?vue&type=style&index=0&id=a0544474&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0544474",
  null
  
)

export default component.exports